import { Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { createGetProductFamilyListOptions } from '../../queries/overviewQueries';
import { DescriptionOverview } from '../../styles';
import CustomSelect from '../atoms/custom-select';
import InputTextAreaField from '../atoms/input-field/inputTextAreaField';
import InputTextField from '../atoms/input-field/inputTextField';
import OverviewInputContainer from './OverviewInputContainer';

function OverviewInput(props) {
  const {
    t,
    handleOnChange,
    handleOnTextChange,
    values,
    setFieldValue,
    overviewInfo,
    inputValidationMessage,
    shouldDisableForm,
  } = props;

  const {
    data: productFamilyData,
    isLoading: _isProductFamilyLoading,
    error: _productFamilyError,
  } = useQuery(
    createGetProductFamilyListOptions({ staleTime: 1000 * 60 * 60 * 1 }) // 1 hour
  );

  const productFamilyOptions = productFamilyData?.map(product_family => {
    return { label: product_family.Name, value: product_family.ID };
  });

  const { ProductFamilyID = '' } = values;

  return (
    <Grid item xs={7}>
      <OverviewInputContainer label={t('Title')}>
        <InputTextField
          placeholder={t('Enter_PECR_title_here')}
          name={'Title'}
          onChange={event => handleOnTextChange(event, 'Title', setFieldValue)}
          pageInfo={overviewInfo}
          value={values.Title}
          maxLength={'100'}
          disabled={props.shouldDisableForm}
          error={props.inputValidationMessage.Title}
        />
      </OverviewInputContainer>
      <br />
      <OverviewInputContainer label={t('Description')}>
        <InputTextAreaField
          placeholder={t('Enter_PECR_description_here')}
          name={'Description'}
          onChange={event =>
            handleOnTextChange(event, 'Description', setFieldValue)
          }
          pageInfo={overviewInfo}
          value={values.Description}
          customStyle={DescriptionOverview}
          disabled={shouldDisableForm}
          maxLength={'1000'}
          error={inputValidationMessage.Description}
        />
      </OverviewInputContainer>
      <br />
      <OverviewInputContainer label={t('Product_Family')}>
        <CustomSelect
          name={'productFamily'}
          id={'ProductFamilyID'}
          placeholder={t('Select_Product_Family_Impacted')}
          options={productFamilyOptions}
          isMulti
          onChange={option =>
            handleOnChange('ProductFamilyID', option, true, setFieldValue)
          }
          value={productFamilyOptions?.filter(each => {
            const SelectedFamilyProduct = ProductFamilyID.split(',').find(
              item => {
                return item.toString() === each.value.toString();
              }
            );
            return SelectedFamilyProduct;
          })}
          isDisabled={shouldDisableForm}
        />
      </OverviewInputContainer>
      <br />
      <OverviewInputContainer label={t('ECR_URL')}>
        <InputTextField
          placeholder={t('Enter_ECR_URL_here')}
          name={'WindchillECRUrl'}
          onChange={event =>
            handleOnTextChange(event, 'WindchillECRUrl', setFieldValue)
          }
          pageInfo={overviewInfo}
          value={values.WindchillECRUrl}
          disabled={shouldDisableForm}
          error={inputValidationMessage.WindchillECRURL}
        />
      </OverviewInputContainer>
    </Grid>
  );
}

OverviewInput.propTypes = {
  t: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnTextChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    Title: PropTypes.string,
    Description: PropTypes.string,
    ProductFamilyID: PropTypes.string,
    WindchillECRURL: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  overviewInfo: PropTypes.object,
  inputValidationMessage: PropTypes.shape({
    Title: PropTypes.string,
    Description: PropTypes.string,
    WindchillECRURL: PropTypes.string,
  }).isRequired,
  shouldDisableForm: PropTypes.bool.isRequired,
};

export default OverviewInput;
